export default "__VITE_ASSET__CY7CyTKy__"